<template>
  <div class="modify-info">
    <div class="header">
      <div class="title">编辑成员信息与权限</div>
    </div>
    <div class="info-con" v-loading="pageLoading">
      <!-- <p class="tips">创建成员后 , 使用此账号可以登录好生意用户管理后台，不可登录好生意商户端，你可以为不同的登录账号设置不同的权限范围</p> -->
      <div class="form">
        <el-form :model="newUserForm" :rules="newUserRules" inline class="inline-form" ref="newUserForm" label-width="100px">
          <div class="form-box">
            <div class="left item-same">
              <el-form-item label="姓名" prop="operatorName">
                <el-input size="small" v-model="newUserForm.operatorName" autocomplete="off" placeholder="请输入成员姓名" clearable/>
              </el-form-item>
              <el-form-item label="手机号" prop="mobile">
                <el-input size="small" v-model.number="newUserForm.mobile" placeholder="请输入成员手机号" clearable/>
              </el-form-item>
              <el-form-item label="密码" prop="password">
                <el-input type="password" size="small" v-model="newUserForm.password" autocomplete="off" placeholder="请输入8~16位数字加字母组合" clearable/>
              </el-form-item>
              <el-form-item label="门店选择" class="storeList" v-if="groupType === 0">
                <custom-select size="small" v-model="merchantIdList" :list="shopList"/>
              </el-form-item>
              <el-form-item label="权限菜单" v-if="groupType === 0">
                <el-checkbox-group v-model="authorityIdList">
                  <el-checkbox v-for="(item, index) in oldMenu" :label="item.id" :key="index + 'o'">{{ item.authorityName }}</el-checkbox>
                  <br>
                  <el-checkbox v-if="newMenuControllerInfo" :label="newMenuControllerInfo.id" @change="handleNewMenuControl">{{ newMenuControllerInfo.authorityName }}</el-checkbox>
                  <br>
                  <div class="new-menu-area">
                    <el-checkbox v-for="(item, index) in newMenu" :label="item.id" :key="index + 'n'" class="new-menu" disabled>{{ item.authorityName }}</el-checkbox>
                  </div>
                </el-checkbox-group>
              </el-form-item>
            </div>
            <div class="right item-same">
              <el-form-item label="账号" prop="loginUserName" v-if="isNewUser">
                <el-input size="small" v-model="newUserForm.loginUserName" autocomplete="off" clearable placeholder="请输入成员账号"/>
              </el-form-item>
              <el-form-item label="账号" prop="loginUserName" v-else>
                <div>{{ newUserForm.loginUserName }}</div>
              </el-form-item>
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" size="small" v-model="newUserForm.remark" placeholder="请输入成员备注信息"/>
              </el-form-item>
            </div>
            <div v-if="groupType !== 0" class="other-shop">
              <div class="store-content">
                <div class="store">
                  <div class="title">门店选择</div>
                  <div class="desc">必须选择大于1个以上的门店，选择门店后此账号可见该门店的相关数据</div>
                  <el-checkbox v-model="isAllCheckedShop">全选</el-checkbox>
                  <el-tree
                    :data="shopListTree"
                    show-checkbox
                    node-key="merchantId"
                    check-strictly
                    ref="tree"
                    :default-expanded-keys="defaultCheckedKeys"
                    :default-checked-keys="defaultCheckedKeys"
                    :props="defaultProps"/>
                </div>
              </div>
              <div class="auth">
                <div class="item first-item">
                  <div class="title">PC后台权限账单</div>
                  <el-checkbox-group v-model="authorityIdList">
                    <el-checkbox v-for="(item,index) in permissonList" :label="item.id" :key="index">{{ item.authorityName }}</el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="item">
                  <div class="title">商户端权限菜单</div>
                  <el-checkbox-group v-model="merchantAuthorId">
                    <el-checkbox v-for="(item,index) in merchantPermission" :label="item.id" :key="index">{{ item.authorityName }}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
          </div>
          <el-form-item class="btn-submit">
            <el-button class="bs-btn2" @click="cancelNewUser">取消</el-button>
            <el-button class="bs-btn" type="primary" @click="submitNewAccount('newUserForm')" :loading="newUserLoading">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { checkPhone, checkPass } from "@/utils/validate";
import CustomSelect from "@/components/CustomSelect/index.vue";
import { queryShopList } from "@/api/merchant-info";
import { listBackstageUserAuthority, saveBackstageUserInfo } from "@/api/member-permisson";

const newMenuList = ['实时交易', '下载中心', '费用明细', '对账单导出'];

export default {
  name: "modify-info",
  components: { CustomSelect },
  data() {
    return {
      newUserRules: {
        operatorName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 1, max: 10, message: "长度在 1 到 10 个字符", trigger: "blur",
          },
          {
            required: true, pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: '姓名不支持特殊字符和空格', trigger: 'blur',
          },
        ],
        loginUserName: [
          { required: true, message: "请输入账号", trigger: "blur" },
          {
            min: 8, max: 16, message: "长度在 8 到 16 个字符", trigger: "blur",
          },
          {
            required: true, pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: '账号不支持特殊字符和空格', trigger: 'blur',
          },
        ],
        password: [{ validator: checkPass, trigger: "blur", required: true }],
        mobile: [{ validator: checkPhone, trigger: "blur", required: true }],
        remark: [
          {
            min: 0, max: 15, message: "长度在 0 到 15 个字符", trigger: "blur",
          },
        ],
      },
      shopList: [],
      shopListTree: [],
      newUserForm: {
        loginUserName: "",
        operatorName: "",
        remark: "",
        password: "",
        mobile: "",
        id: "",
      },
      defaultProps: {
        children: 'children',
        label: 'merchantName',
      },
      defaultCheckedKeys: ['3010011860'],
      isAllCheckedShop: false,
      merchantIdList: [],
      authorityIdList: [],
      merchantAuthorId: [],
      merchantPermission: [],
      newUserLoading: false,
      pageLoading: false,
      permissionList: [],
      isNewUser: true,
      shopType: 1,
      groupType: 0,
      authorId: [],
      memberInfo: {},
    };
  },
  computed: {
    oldMenu() {
      return this.permissionList.filter(i => !newMenuList.includes(i.authorityName) && i.authorityName !== '新菜单列表');
    },
    newMenu() {
      return this.permissionList.filter(i => newMenuList.includes(i.authorityName));
    },
    newMenuControllerInfo() {
      return this.permissionList.filter(i => i.authorityName === '新菜单列表')[0];
    },
  },
  watch: {
    isAllCheckedShop(val) {
      if (val) {
        // 获取权限的merchantName
        const merchantIdArr = this.shopList.map(v => v.merchantId);
        this.$refs.tree.setCheckedKeys(merchantIdArr);
      } else {
        this.$refs.tree.setCheckedKeys([]);
      }
    },
  },
  activated() {
    const memberInfo = JSON.parse(localStorage.getItem("memberInfo"));
    const loginInfo = JSON.parse(localStorage.getItem('LOGIN_INFO'));
    if (this.memberInfo.userName !== memberInfo ? memberInfo.userName : '') {
      this.queryShopList();
      this.memberInfo = { ...memberInfo };
      if (loginInfo) {
        this.shopType = loginInfo.shopType;
        this.merchantId = loginInfo.merchantId;
        this.groupType = loginInfo.groupType;
      }
    }
  },
  created() {
    const loginInfo = JSON.parse(localStorage.getItem('LOGIN_INFO'));
    this.queryShopList();
    this.memberInfo = JSON.parse(localStorage.getItem("memberInfo"));
    if (loginInfo) {
      this.shopType = loginInfo.shopType;
      this.merchantId = loginInfo.merchantId;
      this.groupType = loginInfo.groupType;
    }
  },
  methods: {
    handleNewMenuControl(checked) {
      this.newMenu.forEach((v) => {
        if (checked && !this.authorityIdList.includes(v.id)) {
          this.authorityIdList.push(v.id);
        }
        if (!checked && this.authorityIdList.includes(v.id)) {
          const index = this.authorityIdList.indexOf(v.id);
          this.authorityIdList.splice(index, 1);
        }
      });
    },
    // 赋初始值
    setBaseInfo() {
      const {
        userName = '', operatorName = '', remark = '', mobile = '', id = '', merchantList = [], authorityList = [],
      } = JSON.parse(localStorage.getItem("memberInfo"));
      // 是否是新建
      this.isNewUser = localStorage.getItem("memberInfo") === "{}";
      this.newUserForm.loginUserName = userName;
      this.newUserForm.operatorName = operatorName;
      this.newUserForm.remark = remark;
      this.newUserForm.mobile = mobile;
      this.newUserForm.id = id;
      this.newUserForm.password = localStorage.getItem("memberInfo") === "{}" ? '' : "LLLLLLL999";
      if (this.groupType === 1) {
        this.defaultCheckedKeys = merchantList ? merchantList.map(e => e.merchantId) : [];
      } else if (this.isNewUser) {
        // 非集团商户新增时，门店默认不选中
        this.merchantIdList = merchantList ? merchantList.map(e => e.merchantId) : [this.shopList[0].merchantId];
      }
      if (authorityList) {
        authorityList.forEach((e) => {
          if (e.type === 0) {
            this.authorId.push(e.id);
          }
        });
      } else {
        this.authorId = [];
      }

      if (authorityList) {
        authorityList.forEach((e) => {
          if (e.type === 1) {
            this.merchantAuthorId.push(e.id);
          }
        });
      } else {
        this.merchantAuthorId = [];
      }
    },
    // 获取门店列表
    queryShopList() {
      const params = {
        userName: "", merchantName: "", merchantId: "", pageNo: 1, pageSize: 1000,
      };
      queryShopList(params).then((res) => {
        if (res.data.error_code === 0) {
          this.shopList = res.data.data.list;
          if (this.groupType === 0) {
            res.data.data.list.unshift({ merchantId: "@", merchantName: "全部门店", checked: true });
            this.merchantIdList = [this.shopList[0].merchantId];
          } else {
            let middleTree = [...res.data.data.list];
            // 获取根节点的groupHeadMerchantId
            middleTree = middleTree.sort((a, b) => a.groupType - b.groupType);
            this.shopListTree = this.filterArray(middleTree, middleTree[0].groupHeadMerchantId);
          }
          this.setBaseInfo();
          this.getPermissionList();
        }
      });
    },
    filterArray(data, parent) {
      const tree = [];
      let temp = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].groupHeadMerchantId === parent) {
          const obj = data[i];
          temp = this.filterArray(data, data[i].merchantId);
          if (temp.length > 0) {
            obj.children = temp;
          }
          tree.push(obj);
        }
      }
      return tree;
    },
    cancelNewUser() {
      this.$router.go(-1);
    },
    submitNewAccount(formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const params = {
              id: this.newUserForm.id,
              loginUserName: this.newUserForm.loginUserName,
              operatorName: this.newUserForm.operatorName,
              remark: this.newUserForm.remark,
              mobile: this.newUserForm.mobile,
            };
            if (this.newUserForm.password !== "LLLLLLL999") {
              params.password = this.$md5(this.newUserForm.password);
            } else {
              params.password = this.newUserForm.password;
            }
            params.authorityIdList = this.authorityIdList.concat(this.merchantAuthorId);
            if (this.groupType === 1) {
              params.merchantIdList = [...this.$refs.tree.getCheckedKeys(), ...this.$refs.tree.getHalfCheckedKeys()];
            } else {
              params.merchantIdList = this.shopType ? this.merchantIdList : [this.merchantId];
            }

            // 如果是全部门店，需要遍历获取所有的门店id
            if (this.merchantIdList[0] === "@") {
              params.merchantIdList = [];
              this.shopList.forEach((v) => {
                if (v.merchantId !== "@") {
                  params.merchantIdList.push(v.merchantId);
                }
              });
            }
            // 必须选择一个以上的门店和权限
            if (this.shopType && params.merchantIdList.length === 0) {
              this.$message.error('请选择至少1个以上的门店');
            } else if (params.authorityIdList.length === 0) {
              this.$message.error('请选择至少1个以上的权限');
            } else {
              this.newUserLoading = true;
              saveBackstageUserInfo(params).then((res) => {
                this.newUserLoading = false;
                if (res.data.error_code === 0) {
                  this.$message.success('操作成功');
                  this.$router.push("/member-permisson/detail");
                }
              });
            }
          }
        });
      }
    },
    // 获取权限列表
    getPermissionList() {
      this.pageLoading = true;
      listBackstageUserAuthority().then((res) => {
        this.pageLoading = false;
        if (res.data.error_code === 0) {
          this.permissionList = [];
          this.merchantPermission = [];
          res.data.data.forEach(({ type = -123, id = '', authorityName = '' }) => {
            const item = { id, authorityName };
            if (type === 0) {
              this.permissionList.push(item);
            } else if (type === 1) {
              this.merchantPermission.push(item);
            }
          });
          this.authorityIdList = this.authorId;
        }
      });
    },
  },
};
</script>
<style lang="scss">
.modify-info {
  > .header {
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .info-con {
    padding: 40px 0;

    .form {
      .el-form {
        .form-box {
          display: flex;
          flex-wrap: wrap;
        }

        .el-form-item {
          margin-bottom: 30px;
        }
      }
    }

    .item-same {
      width: 40%;
    }

    .left {
      padding-left: 50px;
    }

    .right {
      padding-right: 50px;
    }

    .tips {
      padding: 0 50px;
      font-size: 14px;
      color: #999;
    }

    .el-form-item__content {
      width: 350px;

      .el-textarea__inner {
        min-height: 135px !important;
      }
    }

    .el-form-item__label {
      text-align: left;
    }

    .btn-submit {
      padding: 30px 50px 0;

      .el-button {
        width: 90px;
        height: 32px;
        line-height: 0px;
      }
    }
  }

  .yk-custom-select-container {
    .el-select {
      .el-select__tags {
        min-width: 365px !important;
        max-width: 365px !important;
        margin-top: 4px;
      }
    }
  }

  .store-content {
    padding: 20px 0;
    background: #f7f7f7;

    .store {
      padding: 40px 50px;
      background: #fff;

      .title {
        font-size: 14px;
        color: #333;
      }

      .desc {
        margin: 12px 0 35px;
        font-size: 12px;
        color: #ccc;
      }
    }

    .el-tree {
      > .el-tree-node {
        padding: 10px 0;
      }

      > .is-focusable {
        border-bottom: 1px solid #eee;
      }

      .is-focusable:last-child {
        border-bottom: none;
      }
    }

    .el-tree-node {
      margin-top: 10px;
    }

    .el-tree-node__content:hover {
      background-color: #fff;
    }

    .is-current {
      .el-tree-node__content {
        background-color: #fff;
      }
    }

    .el-tree-node:last-child {
      padding-bottom: 0;
    }

    .el-checkbox__inner {
      width: 16px;
      height: 16px;
    }

    .el-checkbox__inner::after {
      top: 2px;
      left: 5px;
    }

    .el-tree-node__expand-icon {
      padding-right: 10px;
      font-size: 17px;

      &.el-tree-node__expand-icon {
        color: #595959;
      }

      &.is-leaf {
        color: transparent;
      }
    }
  }

  .auth {
    padding: 10px 50px;

    .title {
      margin-bottom: 20px;
      font-size: 14px;
      color: #333;
    }

    .item {
      padding: 30px 0;
    }

    .first-item {
      border-bottom: 1px solid #eee;
    }
  }

  .other-shop {
    width: 100%;
  }
}

.new-menu-area {
  padding-left: 15px;
  border: 1px solid #ccc;
  border-radius: 8px;
}
</style>
